import api from "./axios";

const SupportTicketService = {
  fetchTickets: async (params = {}) => {
    return api.get("/support-tickets", { params });
  },

  fetchTicketCounts: async (params = {}) => {
    return api.get("/support-tickets/counts", { params });
  },

  fetchTicket: async (id) => {
    return api.get(`/support-tickets/${id}`);
  },

  createTicket: async (data) => {
    return api.post("/support-tickets", data);
  },

  updateTicket: async (id, data) => {
    return api.put(`/support-tickets/${id}`, data);
  },

  replyTicket: async (id, message) => {
    return api.post(`/support-tickets/${id}/reply`, { message });
  },

  exportTickets: async (params = {}) => {
    return api.get("/support-tickets", {
      params: { ...params, export: true },
      responseType: "blob",
    });
  },
};

export default SupportTicketService;
